import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setMVKPhaseAction } from '../actions/mvk_state';
import { Navigation } from '../components/navigation';
function mapStateToProps(state) {
  return {
    currentPhase: state.MVKState.phase,
    isOfferCard: state.MVKState.isOfferCard
  };
}
function mapDispatchToProps(dispatch) {
  return {
    selectPhase: bindActionCreators(setMVKPhaseAction, dispatch)
  };
}
export var NavigationContainer = connect(mapStateToProps, mapDispatchToProps)(Navigation);